// @flow

import './App.css'
import style from './App.scss'

import { Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import React, { PureComponent } from 'react'
import fixedContent from 'frame/hoc/fixedContent'
import * as browserEnv from 'frame/core/browserEnv'
import { PopupComponent } from 'frame/ui/popup'
import store, { history, dispatch } from 'redux/store'
import CMS from './cms/CMS'
import { fetchVisitor } from './visitor'
import { setVars } from 'redux/action'
import * as analysis from 'frame/core/analysis'
import loadTime from 'frame/core/analysis/loadTime'
import vConsole from 'frame/hoc/vConsole'

setTimeout(function(){
  if(window.location.href.indexOf('fengfd.com')>-1){
    document.title="凤凰金信";
  }
})


@vConsole()
@loadTime()
@fixedContent()
export default class extends PureComponent<*> {
  getOauthOption (visitor: any) {
    let oauthUrl = '/weixin/oauth?userinfo=1&url='
    let isOuth = true
    if (!visitor.weixinInfo) {
      isOuth = false
    }
    const { oauthXqkd, oauthFengjr } = visitor.weixinInfo || {}
    if (window.location.href.indexOf('201904-easy-658u5') !== -1) {
      if (!oauthXqkd) {
        isOuth = false
        oauthUrl = '/weixin/oauth?userinfo=1&type=xqkd&url='
      }
      if (!oauthFengjr) {
        isOuth = false
        oauthUrl = '/weixin/oauth?userinfo=1&scope=snsapi_base&url='
      }
    } else if (/\/magpie\//.test(window.location.href)) {
      oauthUrl = '/weixin/oauth?userinfo=1&type=xqkd&url='
    } else if (!oauthFengjr) {
      isOuth = false
    }
    return {
      oauthUrl,
      isOuth
    }
  }

  componentWillMount () {
    analysis.init('fengjr', 'ga')
    dispatch(setVars('landingUrl', window.location.href))
    fetchVisitor().then((visitor: any) => {
      const { oauthUrl, isOuth } = this.getOauthOption(visitor)
      if (
        browserEnv.isInWeixin() &&
        !browserEnv.isInWeixinApp() &&
        !isOuth &&
        window.location.hostname.indexOf('fengjr.com') > -1 &&
        window.location.search.indexOf('requireWxInfo=false') === -1 &&
        window.location.href.indexOf('insurance/thirdparty') === -1
      ) {
        window.location.replace(
          oauthUrl + encodeURIComponent(window.location.href)
        )
      }
    })
  }

  render () {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <div className={style.this}>
            <PopupComponent />
            <Route exact path='/cn/flow/cms/:code' component={CMS} />
            <Route exact path='/cn/flow/cms/magpie/:code' component={CMS} />
          </div>
        </ConnectedRouter>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/fengjr/App.js